import LoaderGif from './assets/table-loader.gif';

const style = {
  height: '3rem',
  width: '3rem',
};

const TableLoader = () => {
  return <img style={style} src={LoaderGif} alt="table-loader" />;
};

export { TableLoader };
